<template>
  <Modal v-model="supplierServiceTermsModal" width="1000" :styles="{top: fromListing ? '20px' : '100px'}" :title="$t('key1000077')">
    <div class="docx">
      <component :is="switchComponent"></component>
    </div>
    <template #footer>
      <Button @click="supplierServiceTermsModal=false">{{ $t('key1000248') }}</Button>
    </template>
  </Modal>
</template>

<script>
import {getHrefPath} from '@/utils/common';
import supplierServiceTermsCN from "@/views/shopping/common/supplierServiceTermsCN";
import supplierServiceTermsUS from "@/views/shopping/common/supplierServiceTermsUS";
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "supplierServiceTermsModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      supplierServiceTermsModal: false,
    };
  },
  computed: {
    fromListing() {
      return this.$store.state.fromListing;
    },
    switchComponent() {
      let component = this.languagesVal === 'zh-CN' ? supplierServiceTermsCN : supplierServiceTermsUS;
      return component;
    },
    // 隐私政策
    privacyPolicyUrl() {
      let url = '/index.html#/privacyPolicy';
      let service = '/yms-shopping-service';
      return getHrefPath(url, service);
    },
  },
  created() {

  },
  components: {
    supplierServiceTermsCN,
    supplierServiceTermsUS
  }
};
</script>
<style scoped lang="less">
.docx {
  padding: 38px;
  background-color: #ffffff;
  color: #000;
  max-height: 600px;
  overflow-y: auto;
}
</style>
